import { Modal as SimpleModal } from '../modal/modal';
import styles from './styles.module.scss';
import { Avatar } from '@/components/custom/avatar/avatar';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { FiAlertCircle, FiX } from 'react-icons/fi';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { InputMask } from '@/components/ui/input';
import unificationImage from '@/assets/images/unification-image.png';

export default function PersonalDataModal({ show, setShow, currentUser, verifiedUser }) {
  const [step, setStep] = useState('review');
  const [seducData, setSeducData] = useState(null);
  const client = useClient();
  let session = localStorage.getItem('session');
  const isStudent = useCheckIncludeProfiles({ only: ['student'] });
  const isProfessor = useCheckIncludeProfiles({ only: ['professor'] });
  const verificated = localStorage.getItem('verificated');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isStudent && !isProfessor) return null;

  const form = useFormik({
    initialValues: {
      name: currentUser.name || '',
      cpf: currentUser.cpfCnpj || ''
    },
    validationSchema: yup.object({
      name: yup.string().required(t('warning.requiredField')),
      cpf: yup.string().required(t('warning.requiredField'))
    }),
    onSubmit: () => handleSubmit()
  });

  const getSeducClassrooms = async () => {
    const { data, error } = await client.fetch(`users/${currentUser.id}/seduc_classrooms`);
    if (error) {
      toast.error('Erro ao buscar turmas');
    }
    setSeducData(data.user);
  };

  const handleSubmit = async () => {
    if (!form.isValid) return;
    setIsSubmitting(true);

    const payload = {
      name: form.values.name,
      cpfCnpj: form.values.cpf,
      'user-detail-attributes': {
        id: currentUser?.userDetail?.id,
        'cpf-verified': true
      }
    };

    const { data, error } = await client.mutate(`users/${currentUser.id}`, payload, { method: 'PUT' });
    if (error) {
      toast.error('Erro ao atualizar os dados cadastrais');
      return;
    } else {
      await getSeducClassrooms();
      setStep('details');
      session.userDetail.cpfVerified = true;
      session.cpfCnpj = form.values.cpf;
      session.name = form.values.name;
      localStorage.setItem('session', JSON.stringify(session));
      toast.success('Dados cadastrais revisados');
      setIsSubmitting(false);
    }
  };

  const syncClassrooms = async () => {
    const { data, error } = await client.mutate(`users/${currentUser.id}/sync_seduc_classrooms`, {}, { method: 'POST' });
    if (error) {
      toast.error('Erro ao sincronizar turmas');
      return;
    }
  };

  const handleClose = () => {
    if (step === 'details' && seducData?.['iseduc-finded']) {
      syncClassrooms();
    }
    setShow(false);
  };

  const updateVerifications = async (key, value) => {
    const { data, error } = await client.mutate(
      `users/${currentUser.id}`,
      {
        'user-detail-attributes': {
          id: currentUser.userDetail.id,
          [key]: value
        }
      },
      { method: 'PUT' }
    );
    if (error) {
      toast.error('Erro ao atualizar verificação');
    }
  };

  useEffect(() => {
    if (verificated === 'false') return;
    if ((isStudent && verifiedUser?.['cpf-verified'] === true && verifiedUser?.['classroom-verified'] !== true) || (isProfessor && verifiedUser && verifiedUser?.['classroom-verified'] !== true)) {
      getSeducClassrooms().then(() => {
        setShow(true);
        setStep('details');
      });
    }
  }, [verifiedUser]);

  const currentYear = new Date().getFullYear();

  return (
    <SimpleModal
      contentClassName="simple-modal active w-[700px] overflow-visible"
      show={show}
      onClose={handleClose}
      hideCloseButton
      closeOnOverlayClick={false}
    >
      {/* Etapa do formulário */}
      {step === 'review' && !isProfessor ? (
        <div style={{ width: '100%' }}>
          <h4
            className={styles.title}
            style={{ fontSize: '2rem', textAlign: 'center' }}
          >
            Revise seus dados cadastrais
          </h4>
          <p style={{ textAlign: 'center' }}>Atualize seus dados e clique no botão abaixo para salvar</p>
          <form onSubmit={form.handleSubmit}>
            <div className="form">
              <label
                className="form__label"
                htmlFor="name"
              >
                Nome completo
              </label>
              <input
                className="form__control"
                placeholder="Nome completo"
                id="name"
                name="name"
                type="text"
                value={form?.values?.name}
                onChange={e => form?.setFieldValue('name', e.target.value)}
              />
              {form?.touched?.name && form?.errors?.name && <span style={{ color: 'red' }}>{form?.errors?.name}</span>}

              <div className="form__row">
                <label
                  htmlFor="cpf"
                  className="form__label"
                >
                  CPF
                </label>
                <InputMask
                  value={form.values.cpf}
                  className="form__control"
                  mask="999.999.999-99"
                  name="cpf"
                  id="cpf"
                  placeholder="CPF"
                  onChange={e => {
                    form.setFieldValue('cpf', e.target.value);
                  }}
                  onBlur={form.handleBlur}
                />
                {form?.touched?.cpf && form?.errors?.cpf && <span style={{ color: 'red' }}>{form?.errors?.cpf}</span>}
              </div>

              <button
                type="submit"
                className="btn btn--primary btn--full u-mt-3 mb-6"
                disabled={isSubmitting}
              >
                Salvar
              </button>
            </div>
          </form>
        </div>
      ) : (
        // Etapa de detalhamento
        <div className={styles.container}>
          {seducData?.['iseduc-finded'] ? (
            <div className={styles.unification}>
              <img
                src={unificationImage}
                alt=""
                className={styles['unification-mascot']}
              />
              <div className={styles['unification-content']}>
                <button
                  type="button"
                  className={styles['unification-close']}
                  onClick={handleClose}
                  aria-label="Fechar"
                >
                  <FiX />
                </button>
                <h4 className={styles.title}>Sua experiência agora está unificada!</h4>
                <p className="mb-4 text-primary-dark">Para facilitar seus estudos, unificamos todo o seu progresso, certificados e histórico nesta conta institucional única vinculada ao seu CPF.</p>

                <div className={`${styles['user-card']} shadow-md`}>
                  <div className={styles['user-avatar']}>
                    <Avatar
                      className={`avatar ${styles['user-avatar--img']}`}
                      src={seducData?.['image-url']}
                    />
                    <span className={`badge badge--primary badge--tiny ${styles['user-avatar--badge']}`}>{currentUser?.profileNames[0]}</span>
                  </div>
                  <div className={styles['user-data']}>
                    <p className={styles['user-data-name']}>{seducData?.name}</p>
                    <p className={styles['user-data-text--disabled']}>CPF: {seducData?.['cpf-cnpj']}</p>
                    <p className={styles['user-data-text--disabled']}>Email: {seducData?.email}</p>

                    <div className={styles['user-academic-data']}>
                      {seducData?.['iseduc-classrooms']?.length > 0 &&
                        seducData['iseduc-classrooms'].map(classroom => (
                          <div
                            key={classroom.id}
                            style={{ marginBottom: '1.5rem' }}
                          >
                            <p className="mb-4">Escola: {classroom.institution?.name}</p>
                            <p className="mb-4">Curso: {classroom.course?.title}</p>
                            <p className="mb-4">Turma: {classroom.title}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                <p className="mb-0 mt-4 text-primary-dark">Seu perfil agora está seguro e sincronizado com os dados da SEDUC. Bons estudos!</p>
              </div>
            </div>
          ) : (
            <>
              <div>
                <h4 className={styles.title}>{isProfessor ? 'Ops! Seu cadastro foi alterado.' : 'CPF não encontrado'}</h4>
                <p className="mb-4">Seu cadastro não foi encontrado na base da SEDUC-PI (iSeduc).</p>
              </div>
              <div className={`${styles['user-card']} shadow-md`}>
                <div className={styles['user-avatar']}>
                  <div className={`avatar ${styles['user-avatar--img']} ${styles['user-avatar--not-finded']}`}>?</div>
                  <span className={`badge badge--primary badge--tiny ${styles['user-avatar--badge']}`}>{currentUser?.profileNames[0]}</span>
                </div>
                <div className={styles['user-data']}>
                  <p className={styles['user-data-name']}>{seducData?.name}</p>
                  <p className={styles['user-data-error']}>CPF: não encontrado</p>
                  <p className={styles['user-data-text--disabled']}>Email: {seducData?.email}</p>
                </div>
              </div>
              <div className={styles['institution-contact']}>
                <span className={`${styles['alert-icon']} ${styles[`alert-icon--danger`]}`}>
                  <FiAlertCircle />
                </span>
                <div>
                  <p
                    style={{ marginBottom: 0 }}
                    className="text-primary-dark"
                  >
                    <b>Atenção: {isProfessor ? 'caso você discorde, atualize seus dados junto à gestão escolar por meio do sistema "Fala, Gestor!".' : 'entre em contato com a gestão escolar para corrigir seus dados.'}</b>
                  </p>
                  {isProfessor ? '' : <p className="mb-4">Para continuar acessando os conteúdos de {currentYear}, é só pedir para a gestão da sua escola atualizar seus dados.</p>}
                </div>
              </div>
              {isStudent ? (
                <div className={styles.buttons}>
                  <button
                    className={`btn ${styles.btn}`}
                    onClick={() => {
                      setShow(false);
                      updateVerifications('classroom-verified', false);
                      localStorage.setItem('verificated', false);
                    }}
                  >
                    Vou entrar em contato com a gestão da minha escola
                  </button>
                </div>
              ) : (
                <div className={styles.buttons}>
                  <button
                    className={`btn btn--outline`}
                    onClick={() => {
                      setShow(false);
                      updateVerifications('classroom-verified', false);
                      localStorage.setItem('verificated', false);
                    }}
                  >
                    Entrarei em contato com a gestão
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </SimpleModal>
  );
}
